import { useQuery } from "@tanstack/react-query";

import {
  ClaimIntegrationControllerApi,
  ClaimIntegrationDto,
} from "../../../services";
import {
  asPaginatedContent,
  getConfigObject,
  useBaseContent,
} from "../../../utils/utils";
/**
 *
 * @author Atish Bagate
 */
interface Props {
  xtenantId: string;
  // ECRH-5375: filter out deleted (archived) payer/clearinghouse configs so
  // they no longer appear in listings or selection dropdowns. Defaults to
  // active-only.
  archive?: boolean;
}

export function useGetClaimIntegration({
  xtenantId,
  archive = false,
}: Props): useBaseContent<ClaimIntegrationDto> {
  return useQuery({
    queryKey: ["get-claim-integration-list", archive],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ClaimIntegrationControllerApi(getConfigObject())
        .getConfigurations1(archive, xtenantId)
        .then((it) => asPaginatedContent<ClaimIntegrationDto>(it?.data)),
  });
}
